

export const mockResponseExact = {
	isMock: true,
    "errorMessage": "",
    "status": "success",
    "offices": [
        "GB",
        "MY",
        "NZ",
        "AU",
        "SG",
        "US",
        "IN",
        "DE",
        "FR",
        "ES",
        "CH",
        "CA",
        "MX",
        "WO",
        "EM",
        "BR",
        "JP",
        "KR",
        "IT"
    ],
    "matches": [
        {
            "NiceClass": 30,
            "term": null,
            "nbTotalOccurences": 18122,
            "nbOccurences": [
                5983
            ],
            "nbOccurencesTimeline": [
                [
                    572,
                    917,
                    527,
                    571,
                    674,
                    576,
                    591,
                    589,
                    468,
                    227,
                    127,
                    138,
                    8
                ],
                [
                    42,
                    38,
                    39,
                    41,
                    54,
                    41,
                    52,
                    52,
                    55,
                    48,
                    50,
                    32,
                    0
                ],
                [
                    0,
                    9,
                    31,
                    43,
                    52,
                    44,
                    39,
                    51,
                    34,
                    47,
                    36,
                    23,
                    0
                ],
                [
                    35,
                    67,
                    51,
                    67,
                    70,
                    70,
                    91,
                    104,
                    61,
                    83,
                    62,
                    61,
                    7
                ],
                [
                    71,
                    45,
                    51,
                    57,
                    82,
                    79,
                    109,
                    121,
                    59,
                    78,
                    97,
                    74,
                    19
                ],
                [
                    59,
                    83,
                    48,
                    78,
                    87,
                    108,
                    94,
                    115,
                    96,
                    76,
                    56,
                    13,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    3,
                    49,
                    33,
                    10,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    24,
                    42,
                    19,
                    6,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    86,
                    250,
                    193,
                    213,
                    239,
                    278,
                    297,
                    327,
                    242,
                    275,
                    283,
                    329,
                    91
                ],
                [
                    519,
                    843,
                    434,
                    458,
                    531,
                    439,
                    394,
                    374,
                    395,
                    351,
                    259,
                    213,
                    37
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    2,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]
            ],
            "similarityScore": 0,
            "type": 2,
            "typeString": "nice",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": true,
            "transformedData": [
                {
                    "office": "AU",
                    "data": [
                        35,
                        67,
                        51,
                        67,
                        70,
                        70,
                        91,
                        104,
                        61,
                        83,
                        62,
                        61,
                        7
                    ],
                    "total": 829,
                    "show": true,
                    "group": "apexcharts-axis-0"
                },
                {
                    "office": "BR",
                    "data": [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        2,
                        2,
                        0,
                        0,
                        0
                    ],
                    "total": 4,
                    "show": true,
                    "group": "apexcharts-axis-0"
                },
                {
                    "office": "CA",
                    "data": [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        24,
                        42,
                        19,
                        6,
                        0,
                        0
                    ],
                    "total": 91,
                    "show": true,
                    "group": "apexcharts-axis-0"
                },
                {
                    "office": "CH",
                    "data": [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0,
                        0,
                        0,
                        0
                    ],
                    "total": 1,
                    "show": true,
                    "group": "apexcharts-axis-0"
                },
                {
                    "office": "DE",
                    "data": [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    "total": 0,
                    "show": false
                },
                {
                    "office": "EM",
                    "data": [
                        519,
                        843,
                        434,
                        458,
                        531,
                        439,
                        394,
                        374,
                        395,
                        351,
                        259,
                        213,
                        37
                    ],
                    "total": 5247,
                    "show": true,
                    "group": "apexcharts-axis-0"
                },
                {
                    "office": "ES",
                    "data": [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    "total": 0,
                    "show": false
                },
                {
                    "office": "FR",
                    "data": [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    "total": 0,
                    "show": false
                },
                {
                    "office": "GB",
                    "data": [
                        572,
                        917,
                        527,
                        571,
                        674,
                        576,
                        591,
                        589,
                        468,
                        227,
                        127,
                        138,
                        8
                    ],
                    "total": 5985,
                    "show": true,
                    "group": "apexcharts-axis-0"
                },
                {
                    "office": "IN",
                    "data": [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        3,
                        49,
                        33,
                        10,
                        0,
                        0
                    ],
                    "total": 95,
                    "show": true,
                    "group": "apexcharts-axis-0"
                },
                {
                    "office": "IT",
                    "data": [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    "total": 0,
                    "show": false
                },
                {
                    "office": "JP",
                    "data": [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    "total": 0,
                    "show": false
                },
                {
                    "office": "KR",
                    "data": [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    "total": 0,
                    "show": false
                },
                {
                    "office": "MX",
                    "data": [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    "total": 0,
                    "show": false
                },
                {
                    "office": "MY",
                    "data": [
                        42,
                        38,
                        39,
                        41,
                        54,
                        41,
                        52,
                        52,
                        55,
                        48,
                        50,
                        32,
                        0
                    ],
                    "total": 544,
                    "show": true,
                    "group": "apexcharts-axis-0"
                },
                {
                    "office": "NZ",
                    "data": [
                        0,
                        9,
                        31,
                        43,
                        52,
                        44,
                        39,
                        51,
                        34,
                        47,
                        36,
                        23,
                        0
                    ],
                    "total": 409,
                    "show": true,
                    "group": "apexcharts-axis-0"
                },
                {
                    "office": "SG",
                    "data": [
                        71,
                        45,
                        51,
                        57,
                        82,
                        79,
                        109,
                        121,
                        59,
                        78,
                        97,
                        74,
                        19
                    ],
                    "total": 942,
                    "show": true,
                    "group": "apexcharts-axis-0"
                },
                {
                    "office": "US",
                    "data": [
                        59,
                        83,
                        48,
                        78,
                        87,
                        108,
                        94,
                        115,
                        96,
                        76,
                        56,
                        13,
                        0
                    ],
                    "total": 913,
                    "show": true,
                    "group": "apexcharts-axis-0"
                },
                {
                    "office": "WO",
                    "data": [
                        86,
                        250,
                        193,
                        213,
                        239,
                        278,
                        297,
                        327,
                        242,
                        275,
                        283,
                        329,
                        91
                    ],
                    "total": 3103,
                    "show": true,
                    "group": "apexcharts-axis-0"
                }
            ]
        },
        {
            "NiceClass": 35,
            "term": null,
            "nbTotalOccurences": 25,
            "nbOccurences": [
                11
            ],
            "nbOccurencesTimeline": [
                [
                    1,
                    2,
                    0,
                    0,
                    1,
                    1,
                    6,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    2,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    1,
                    2,
                    0,
                    0,
                    1,
                    1,
                    6,
                    0,
                    0,
                    0,
                    0,
                    1,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ],
                [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ]
            ],
            "similarityScore": 0,
            "type": 0,
            "typeString": "all",
            "startYear": 0,
            "nbYears": 0,
            "exactMatch": true,
            "transformedData": [
                {
                    "office": "AU",
                    "data": [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    "total": 0,
                    "show": false
                },
                {
                    "office": "BR",
                    "data": [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    "total": 0,
                    "show": false
                },
                {
                    "office": "CA",
                    "data": [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    "total": 0,
                    "show": false
                },
                {
                    "office": "CH",
                    "data": [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    "total": 0,
                    "show": false
                },
                {
                    "office": "DE",
                    "data": [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    "total": 0,
                    "show": false
                },
                {
                    "office": "EM",
                    "data": [
                        1,
                        2,
                        0,
                        0,
                        1,
                        1,
                        6,
                        0,
                        0,
                        0,
                        0,
                        1,
                        0
                    ],
                    "total": 12,
                    "show": true
                },
                {
                    "office": "ES",
                    "data": [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    "total": 0,
                    "show": false
                },
                {
                    "office": "FR",
                    "data": [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    "total": 0,
                    "show": false
                },
                {
                    "office": "GB",
                    "data": [
                        1,
                        2,
                        0,
                        0,
                        1,
                        1,
                        6,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    "total": 11,
                    "show": true
                },
                {
                    "office": "IN",
                    "data": [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    "total": 0,
                    "show": false
                },
                {
                    "office": "IT",
                    "data": [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    "total": 0,
                    "show": false
                },
                {
                    "office": "JP",
                    "data": [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    "total": 0,
                    "show": false
                },
                {
                    "office": "KR",
                    "data": [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    "total": 0,
                    "show": false
                },
                {
                    "office": "MX",
                    "data": [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    "total": 0,
                    "show": false
                },
                {
                    "office": "MY",
                    "data": [
                        0,
                        0,
                        0,
                        0,
                        0,
                        2,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    "total": 2,
                    "show": true
                },
                {
                    "office": "NZ",
                    "data": [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    "total": 0,
                    "show": false
                },
                {
                    "office": "SG",
                    "data": [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    "total": 0,
                    "show": false
                },
                {
                    "office": "US",
                    "data": [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    "total": 0,
                    "show": false
                },
                {
                    "office": "WO",
                    "data": [
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0,
                        0
                    ],
                    "total": 0,
                    "show": false
                }
            ]
        }
    ],
    "startYear": 2012,
    "endYear": 0,
    "version": "2.0",
    "original_term": "sushi"
}